module.exports = __webpack_public_path__ + "img/chat.214f290b.svg";